import Vue from "vue";
import api from "@/api";

export default {
	actions: {
		async GetRecruitmentList() {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetRecruitmentList,
			});
			return response;
		},
		async GetRecruitment(_, entryId) {
			let response = await Vue.axios({
				method: "GET",
				url: api.GetRecruitment + entryId,
			});
			return response.data;
		},
		async CreateRecruitment(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.CreateRecruitment,
				data: entry,
			});
			return response.data;
		},
		async UpdateRecruitment(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.UpdateRecruitment,
				data: entry,
			});
			return response.data;
		},
		async DeleteRecruitment(_, entry) {
			let response = await Vue.axios({
				method: "POST",
				url: api.DeleteRecruitment,
				data: entry,
			});
			return response.data;
		},
	},
};
